export const endpointMapping = {
  oeeManagementRoute: {
    main: '/common/oeeData',
    firstLevel: '/api/oeeManagementRoute/machineWise',
    firstLevelFrontendPage:'/common/OEEAnalysis',
    monthYearRouting: false,
  },
  fourMChangeDashboardGraphRoute:{
    firstLevelFrontendPage: '/common/combinedTable',
    monthYearRouting: false,
    monthYearDateField: 'annual_date',
    firstLevel:'fourMChangeDashboardGraphRoute/changesForTable'
  },
  pendingReportsRoute: {
    main: '',
    firstLevel: 'pendingReportsRoute/pending-reports',
    firstLevelFrontendPage: '/common/dashboardData'
  },
  machineBreakdownGraphDataMonthly: {
    main: '',
    firstLevel: '',
    firstLevelFrontendPage: '/common/monthlyMachineBreakDownReord'
  },
  toolBreakdownGraphDataMonthly: {
    main: '',
    firstLevel: '',
    firstLevelFrontendPage: '/common/toolBreakdownRecord'
  },
  graphMonthlyMinorBreakdownRoute:{
    firstLevelFrontendPage: '/common/minorBreakdownTable',
    firstLevel:'graphMonthlyMinorBreakdownRoute/getMinorBreakdownsForTable'
  },
  graphMonthlyProductionRoute:{
    firstLevelFrontendPage: '/analysis/production-analysis',
    firstLevel: ''
  },
  graphMonthlyRejectionRoute:{
    firstLevelFrontendPage: '/analysis/rejection-analysis',
    firstLevel: ''
  }
};